import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import {
  SuggestedMyLeaderGroupsLoadFulfilledAction,
  SuggestedMyLeaderGroupsLoadPendingAction,
  SuggestedMyLeaderGroupsLoadRejectedAction,
} from '../../domains/suggestedMyLeaderGroups/actions.types';

import { ViewerSuggestedMyLeaderGroups } from './types';
const initialState: ViewerSuggestedMyLeaderGroups = {
  pending: false,
  fulfilled: undefined,
  rejected: undefined,
};

const moveToFulfilled = (
  state: ViewerSuggestedMyLeaderGroups,
  action: SuggestedMyLeaderGroupsLoadFulfilledAction
): ViewerSuggestedMyLeaderGroups => {
  if (!state.fulfilled) {
    return setFulfilled({
      suggestedMyLeaderGroups: action.payload.entities.viewerSuggestedMyLeaderGroups.suggestedMyLeaderGroups,
    });
  }

  return {
    ...state,
    fulfilled: {
      ...state.fulfilled,
      suggestedMyLeaderGroups: [
        ...new Set([
          ...state.fulfilled.suggestedMyLeaderGroups,
          ...action.payload.entities.viewerSuggestedMyLeaderGroups.suggestedMyLeaderGroups,
        ]),
      ],
    },
  };
};

export type ViewerSuggestedMyLeaderGroupsAction =
  | SuggestedMyLeaderGroupsLoadFulfilledAction
  | SuggestedMyLeaderGroupsLoadPendingAction
  | SuggestedMyLeaderGroupsLoadRejectedAction;

const reducer: Reducer<ViewerSuggestedMyLeaderGroups, ViewerSuggestedMyLeaderGroupsAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'SUGGESTED_MY_LEADER_GROUPS.LOAD_FULFILLED':
      return moveToFulfilled(state, action);
    case 'SUGGESTED_MY_LEADER_GROUPS.LOAD_PENDING':
      return setPending();
    case 'SUGGESTED_MY_LEADER_GROUPS.LOAD_REJECTED':
      return setRejected(action.payload.error);
    default:
      return state;
  }
};

export default reducer;
